<template>
  <v-row>
    <v-col v-if="modelLiquidation.nombre === 'MENSUALES'">
      <p class="mx-auto text-center">Este modelo no puede tener instancias</p>
    </v-col>
    <v-col v-else>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        @headersUpdated="updateHeaders"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
      />
      <v-dialog
        v-model="open"
        max-width="520px"
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :items="dataInputs"
          @save="save"
          @cancel="reset"
          :maxWidth="maxWidth[1]"
          :mode="mode"
          :show="true"
          :showDate="true"
          :itemsCheckbox="dataCheckboxes"
          :showCheck="false"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import instance from "@/models/modelosDeLiquidacion/Relations/instance";
import date from "@/store/common/date";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("modelsLiquidations.instances"),
      titleTable: "ModelosDeLiquidacion_Instancias",
      titleDelete: this.$tc("modelsLiquidations.toInstancesLiquidation"),
      isLoading: true,
      maxWidth: ["550px", "520px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Max horas extras",
          value: "overtimeLimit",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desde",
          value: "dateStart",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Hasta",
          value: "dateEnd",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Repite",
          value: "repitXyear",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      dataInputs: [
        {
          name: "name",
          label: this.$tc("modelsLiquidations.nameInstace"),
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$tc("costCenter.rulesDataName50chart"),
          ],
        },
        {
          name: "overtimeLimit",
          label: this.$tc("modelsLiquidations.overtimeLimit"),
          data: 0,
          type: "number",
          rules: [
            (v) =>
              (v !== null && v !== undefined) ||
              this.$tc("editRegistrations.requerid"),
            (v) =>
              (v >= 0 && v <= 100) ||
              this.$tc("modelsLiquidations.ruleOvertimeLimit"),
          ],
        },
      ],
      dataCheckboxes: [
        {
          name: "repitXyear",
          label: this.$tc("modelsLiquidations.repitXyear"),
          data: true,
        },
      ],
    };
  },
  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    items() {
      if (
        !modelsLiquidation.state.edit.instancias ||
        modelsLiquidation.state.edit.instancias.length === 0
      ) {
        return [];
      }

      return modelsLiquidation.state.edit.instancias.map((item) => {
        return instance.fromJson(item);
      });
    },
    modelLiquidation() {
      return modelsLiquidation.state.edit;
    },

    mode: {
      get() {
        return modelsLiquidation.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return modelsLiquidation.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return modelsLiquidation.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    this.isLoading = false;
  },
  methods: {
    async refreshItems() {
      if (modelsLiquidation.state.edit.id) {
        await modelsLiquidation.dispatch(
          "getLiquidationModelId",
          modelsLiquidation.state.edit.id
        );
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    save(items) {
      switch (this.typeForm) {
        case "add":
          this.addInstance(items);
          break;
        case "edit":
          this.editInstance(items);
          break;
        default:
          break;
      }
    },

    addInstance(form) {
      let payload = form;
      payload.repitXyear = form.repitXyear === "true";
      payload.dateStart = date.state.dateFrom;
      payload.dateEnd = date.state.dateTo;
      payload.liqModeloId = modelsLiquidation.state.edit.id;
      modelsLiquidation.commit("setNew", payload);
      modelsLiquidation
        .dispatch("addInstance")
        .then(() => {
          this.showAlert(
            this.$tc("modelsLiquidations.addInstanceToLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((error) => {
          if (error.response && error.response.status === 406) {
            this.showAlert(
              this.$tc("modelsLiquidations.errorInstance406"),
              "#ff8d58"
            );
          } else {
            this.showAlert(
              this.$tc("modelsLiquidations.errorInstance"),
              "#ff8d58"
            );
          }
        });
      this.reset(false);
    },

    editInstance(form) {
      let payload = this.detectChanges(form);
      if (Object.keys(payload).length > 0) {
        payload.fecDesdeOld = this.oldItems.dateStartInput + "T00:00:00.000Z";
        payload.repitXyear = form.repitXyear === "true";
        payload.liqModeloId = modelsLiquidation.state.edit.id;
        payload.oldItems = this.oldItems;

        modelsLiquidation.commit("setEditRelation", payload);
        modelsLiquidation
          .dispatch("editInstance")
          .then(() => {
            this.showAlert(
              this.$tc("modelsLiquidations.editInstanceToLiquidationSuccess"),
              "#82A1D0"
            );
          })
          .catch((error) => {
            if (error.response && error.response.status === 406) {
              this.showAlert(
                this.$tc("modelsLiquidations.errorInstance406"),
                "#ff8d58"
              );
            } else {
              this.showAlert(
                this.$tc("modelsLiquidations.errorInstance"),
                "#ff8d58"
              );
            }
            this.reset(false);
            reject(error);
          });
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },
    detectChanges(newItems) {
      newItems.dateStartInput = date.state.dateFrom;
      newItems.dateEndInput = date.state.dateTo;

      const changes = {};
      const oldItem = this.oldItems;

      if (oldItem) {
        if (oldItem.dateStartInput !== newItems.dateStartInput) {
          changes.dateStartInput = newItems.dateStartInput;
        }

        if (oldItem.dateEndInput !== newItems.dateEndInput) {
          changes.dateEndInput = newItems.dateEndInput;
        }

        if (oldItem.overtimeLimit !== Number(newItems.overtimeLimit)) {
          changes.overtimeLimit = newItems.overtimeLimit;
        }

        if (oldItem.repitXyear !== newItems.repitXyear) {
          changes.repitXyear = newItems.repitXyear;
          if (changes.repitXyear === undefined && oldItem.repitXyear === "") {
            delete changes.repitXyear;
          }
        }

        if (oldItem.name !== newItems.name) {
          changes.name = newItems.name;
        }
      }

      return changes;
    },

    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          date.state.checkTo = false;
          modelsLiquidation.commit(
            "setModeFormRelation",

            this.$tc("modelsLiquidations.addInstancesToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "edit":
          date.state.checkTo = false;
          this.oldItems = item;
          this.itemId = item.id;
          await this.setEdit(item);
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.editInstancesToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "delete":
          modelsLiquidation.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            liqModeloId: modelsLiquidation.state.edit.id,
          };
          break;

        default:
          break;
      }
    },

    setEdit(item) {
      date.state.dateFrom = item.dateStartInput;
      date.state.dateTo = item.dateEndInput;
      this.dataInputs[0].data = item.name;
      this.dataInputs[1].data = item.overtimeLimit;
      this.dataCheckboxes[0].data = item.repitXyear;
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.resetDate();
      modelsLiquidation.commit("setOpenFormRelation", value);
      this.dataInputs.forEach((item) => {
        item.data = "";
      });
    },

    deleteItem() {
      modelsLiquidation.commit("setItemDelete", this.itemToDelete);
      modelsLiquidation
        .dispatch("deleteInstance")
        .then(() => {
          this.openDelete = false;
          modelsLiquidation.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("modelsLiquidations.deleteInstanceToLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.deleteModelLiquidationError"),
            "#ff8d58"
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      modelsLiquidation.commit("setOpenDelete", false);
    },
  },
};
</script>
